import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import Select, {components, DropdownIndicatorProps} from "react-select";
import set from "lodash.set";
import {Button, Table, Form} from "react-bootstrap";
import BalanceFooter from "./BalanceFooter";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import del from "../../assets/icons/del.png";
import add from "../../assets/icons/add.png";
import {Typography} from "@material-ui/core";

export class FertilizersCalculationTables extends Component {

    constructor(props) {
        super(props);
        this.state = {
            main_rows: [],
            pre_sowing_rows: [],
            feed_rows: [],
            balance_row: [],
            columns_main: [],
            columns_feed: [],
            columns_pre_sowing: [],
            update: false,
            fertilizers_mineral_list: [],
            balance_columns: [],
        }
        this.calculateFertilizers = this.calculateFertilizers.bind(this)
        this.addRow = this.addRow.bind(this)
        this.deleteRow = this.deleteRow.bind(this)
        this.calcBalance = this.calcBalance.bind(this)
        this.sumElements = this.sumElements.bind(this)
        this.BalanceBackLight = this.BalanceBackLight.bind(this)
        this.handleChangeCoefP = this.handleChangeCoefP.bind(this)
        this.isDisable = this.isDisable.bind(this)
    }


    componentDidMount() {
        this.populateData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.coefP !== prevProps.coefP && !this.props.report_loading) {
            this.calcBalance(false)
            this.props.calculate_main()
        }
    }

    sumElements(rows) {
        let sumRows = {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0, price: 0, input_price: 0};
        // eslint-disable-next-line array-callback-return
        rows.map((row) => {
            sumRows.n += Number(row.element.n)
            sumRows.p2O5 += Number(row.element.p2O5)
            sumRows.k2O += Number(row.element.k2O)
            sumRows.s += Number(row.element.s)
            sumRows.caO += Number(row.element.caO)
            sumRows.mg += Number(row.element.mg)
            sumRows.price += Number(row.price)
            sumRows.input_price += Number(row.input_price ? row.input_price : 0) * Number(row.fertilizer_count) / 1000
        })
        return sumRows

    }

    calcBalance(isCalc) {
        const changed_rows = this.props.changed_rows
        const balance = this.props.balance[0].element
        const feed = this.sumElements(this.state.feed_rows)
        const pre_sowing = this.sumElements(this.state.pre_sowing_rows)
        const main = isCalc ? this.sumElements(this.state.main_rows) : this.sumElements(changed_rows)
        const sum_limit = [feed.n + pre_sowing.n + main.n,
            feed.p2O5 + pre_sowing.p2O5 * this.props.coefP + main.p2O5,
            feed.k2O + pre_sowing.k2O + main.k2O,
            feed.s + pre_sowing.s + main.s,
            feed.caO + pre_sowing.caO + main.caO,
            feed.mg + pre_sowing.mg + main.mg
        ]
        if (isCalc) {
            this.props.setFertilizerLimit(sum_limit)
        }
        const balanceCalc = [{
            price: (feed.price + pre_sowing.price + main.price).toFixed(2),
            input_price: (feed.input_price + pre_sowing.input_price + main.input_price) * this.props.area,
            element: {
                n: (balance.n - sum_limit[0]).toFixed(2),
                p2O5: (balance.p2O5 - sum_limit[1]).toFixed(2),
                k2O: (balance.k2O - sum_limit[2]).toFixed(2),
                s: (balance.s - sum_limit[3]).toFixed(2),
                caO: (balance.caO - sum_limit[4]).toFixed(2),
                mg: (balance.mg - sum_limit[5]).toFixed(2),
            }
        }]
        if (isCalc) {
            this.setState({balance_row: balanceCalc})
            this.props.setSumPrice(Number(balanceCalc[0].price) + (this.props.useInputPrice ? Number(balanceCalc[0].input_price) : 0))
        } else {
            this.props.fertilizer_data.balance = balanceCalc
        }
    }

    BalanceBackLight(value, el) {
        let conf_interval = 0.4
        let class_name = ""
        if (!this.props.isActive[el])
            class_name = class_name.concat("disable")
        if (Number(value) <= 0 - conf_interval) {
            class_name = class_name.concat("blue-cell")
        } else if (Number(value) <= conf_interval) {
            class_name = class_name.concat("green-cell")
        } else {
            class_name = class_name.concat("red-cell")
        }
        return class_name
    }

    isDisable(el) {
        if (!this.props.isActive[el])
            return 'disable'
        else
            return ''
    }

    addRow(table) {
        this.state[table].push({
            id: this.state[table].at(-1) ? this.state[table].at(-1).id + 1 : 0,
            fertilizerId: 0,
            fertilizer_count: 0,
            price: 0,
            element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0}
        })
        this.recalculateRows(this.state.main_rows)
        this.recalculateRows(this.state.feed_rows)
        this.recalculateRows(this.state.pre_sowing_rows)
        this.setState({update: !this.state.update})
    }

    deleteRow(rowId, table) {
        const row = this.state[table].find(row => row.id === rowId)
        this.state[table].splice(this.state[table].findIndex(row => row.id === rowId), 1)
        if (table !== 'main_rows') {
            this.calcBalance(false)
            this.props.calculate_main()
        } else {
            let changed_rows = this.props.changed_rows
            let changed_id = changed_rows.findIndex((row=>row.id===rowId))
            if(changed_id!==-1){
                this.props.changed_rows[changed_id].visible=false
            }else {
                changed_rows.push({
                    id: "n".concat(row.id),
                    fertilizerId: row.fertilizerId,
                    fertilizer_count: 0,
                    price: 0,
                    element: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, caO: 0},
                    visible: false
                })
                this.props.not_calculate_fertilizers_list.clear()
                changed_rows.map((row) => this.props.not_calculate_fertilizers_list.add(row.fertilizerId))
                this.calcBalance(false)
                this.props.recalculate_A_c()
            }
        }
        this.setState({update: !this.state.update})
    }

    calculateFertilizers() {
        this.recalculateRows(this.state.main_rows)
        this.recalculateRows(this.state.pre_sowing_rows)
        this.recalculateRows(this.state.feed_rows)
        let changed_rows = this.props.changed_rows
        changed_rows.splice(0, changed_rows.length)
        this.forceUpdate()
        this.calcBalance(false)
        this.props.not_calculate_fertilizers_list.clear()
        this.props.recalculate_A_c()
    }

    recalculateRows(rows) {
        if (this.state.fertilizers_mineral_list.length > 0) {
            // eslint-disable-next-line array-callback-return
            rows.map(r => {
                let fertilizer = this.state.fertilizers_mineral_list.find(f => f.value === r.fertilizerId)
                r.element = fertilizer ? {
                    n: (r.fertilizer_count * fertilizer.element.n).toFixed(1),
                    p2O5: (r.fertilizer_count * fertilizer.element.p2O5).toFixed(1),
                    k2O: (r.fertilizer_count * fertilizer.element.k2O).toFixed(1),
                    s: (r.fertilizer_count * fertilizer.element.s).toFixed(1),
                    caO: (r.fertilizer_count * fertilizer.element.caO).toFixed(1),
                    mg: (r.fertilizer_count * fertilizer.element.mg).toFixed(1)
                } : {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0}
                r.price = fertilizer ? (fertilizer.price * r.fertilizer_count / 1000 * this.props.area).toFixed(2) : 0
            })
        }
    }

    recalculateRowFromElements(row, field) {
        if (this.state.fertilizers_mineral_list.length > 0) {
            let fertilizer = this.state.fertilizers_mineral_list.find(f => f.value === row.fertilizerId)
            if (fertilizer && fertilizer.element[field] !== 0) {
                row.fertilizer_count = row.element[field] / fertilizer.element[field]
                for (const el in (fertilizer.element)) {
                    if (el !== field)
                        row.element[el] = (row.fertilizer_count * fertilizer.element[el]).toFixed(1)
                }
                row.price = (fertilizer.price * row.fertilizer_count / 1000 * this.props.area).toFixed(2)
            } else
                row.element[field] = 0
        }
    }

    handleChangeCoefP(event) {
        this.props.changeCoefP(event.target.value)
        this.calcBalance(false)
    }

    static renderTable(columns_main, columns_pre_sowing, columns_feed, main_rows, pre_sowing_rows, feed_rows,
                       balance_row, balance_columns, calculateFertilizers, addRow, handleChangeCoefP, coefP,
                       isDisable, showModal, useInputPrice, setUseInputPrice) {
        const content = <div id="balance_calculation_table" className="balance_calculation_table">
            <Grid
                columns={balance_columns}
                rows={balance_row}
                rowHeight={75}
                isScrollable={false}
                getRowKey={balance_row => balance_row.id}
                disabledCellChecker={(balance_row, columnId) => {
                    return columnId === 'N' ||
                        columnId === 'P2O5' ||
                        columnId === 'K2O' ||
                        columnId === 'S' ||
                        columnId === 'CaO' ||
                        columnId === 'Mg' ||
                        columnId === 'balance' ||
                        columnId === 'price'
                }}
            />
        </div>
        return (
            <div className="fertilizer-calculation" id='fertilizer-calculation'>
                <div className='fertilizer-table-label'>Авторасчет удобрений</div>
                <div className="buttons-row">
                    <Button className="btn-fertilizer-list col" onClick={showModal}>Удобрения используемые в
                        расчетах</Button>
                    <div className="fertilizer-button-wrapper-1 col">
                        <Button className="calculate-fertilizer-button"
                                onClick={calculateFertilizers}>Рассчитать</Button>
                    </div>
                </div>
                <Table className="fertilizer-calculation-table">
                    <thead className="align-middle">
                    <tr>
                        <th style={{width: '26%'}}>Тип удобрения</th>
                        <th style={{width: '10%'}}>Кол-во удобрения,<br/>кг/га</th>
                        <th style={{width: '9%'}}>N<br/>кг/га</th>
                        <th style={{width: '9%'}}>P₂O₅<br/>кг/га</th>
                        <th style={{width: '9%'}}>K₂O<br/>кг/га</th>
                        <th style={{width: '9%'}} className={isDisable('s')}>S<br/>кг/га</th>
                        <th style={{width: '9%'}} className={isDisable('caO')}>CaO<br/>кг/га</th>
                        <th style={{width: '9%'}} className={isDisable('mg')}>Mg<br/>кг/га</th>
                        <th style={{width: '10%'}}>Стоимость, руб/поле</th>
                        {/*<th width="8%" className='input-price-cell'>Стоимость внесения,<br/>руб/т*/}
                        {/*<input className='input-price-checkbox' type='checkbox' checked={useInputPrice} onClick={setUseInputPrice}/></th>*/}
                    </tr>
                    </thead>
                </Table>
                <div id="main_calculation_table" style={{position: "sticky", zIndex: "6"}}>
                    <div className="fertilizer_calculation-label">Основное внесение</div>
                    <>
                        <Grid
                            columns={columns_main}
                            rows={main_rows}
                            rowHeight={75}
                            focusOnSingleClick={true}
                            isScrollable={false}
                            getRowKey={main_rows => main_rows.id}
                            disabledCellChecker={(main_rows, columnId) => {
                                return columnId === 'fertilizer' ||
                                    columnId === 'fertilizer_type' ||
                                    columnId === 'button_remove' ||
                                    columnId === 'price'
                            }}
                        />
                    </>
                    <div className="add-btn-container">
                        <button className="btn add-btn" onClick={() => addRow("main_rows")}><img src={add} alt='add'/>
                        </button>
                    </div>
                </div>
                <div id="main_calculation_table" style={{position: "sticky", zIndex: "5"}}>
                    <div className="fertilizer_calculation-label">Припосевное внесение (Повышающий коэффициент усвоения
                        фосфора:
                        <Form className="p-input" onSubmit={(e)=>e.preventDefault()}>
                        <Form.Control
                                      value={coefP}
                                      placeholder='0'
                                      onClick={(e) => e.target.select()}
                                      style={{width: '40px', marginLeft: '10px', marginRight: '5px'}}
                                      onChange={handleChangeCoefP}>
                        </Form.Control> </Form>)
                    </div>
                    <Grid
                        columns={columns_pre_sowing}
                        rows={pre_sowing_rows}
                        focusOnSingleClick={true}
                        isScrollable={false}
                        rowHeight={75}
                        getRowKey={pre_sowing_rows => pre_sowing_rows.id}
                        disabledCellChecker={(pre_sowing_rows, columnId) => {
                            return columnId === 'fertilizer' ||
                                columnId === 'fertilizer_type' ||
                                columnId === 'button_remove' ||
                                columnId === 'price'
                        }}
                    />
                    <div className="add-btn-container">
                        <button className="btn add-btn" onClick={() => addRow("pre_sowing_rows")}>
                            <img src={add} alt='add'/>
                        </button>
                    </div>
                </div>
                <div id="main_calculation_table" style={{position: "sticky", zIndex: "4"}}>
                    <div className="fertilizer_calculation-label">Подкормка</div>
                    <Grid
                        columns={columns_feed}
                        rows={feed_rows}
                        focusOnSingleClick={true}
                        rowHeight={75}
                        isScrollable={false}
                        getRowKey={feed_rows => feed_rows.id}
                        disabledCellChecker={(feed_rows, columnId) => {
                            return columnId === 'fertilizer' ||
                                columnId === 'fertilizer_type' ||
                                columnId === 'button_remove' ||
                                columnId === 'price'
                        }}
                    />
                    <div className="add-btn-container">
                        <button className="btn add-btn" onClick={() => addRow("feed_rows")}><img src={add} alt='add'/>
                        </button>
                    </div>
                </div>
                <div className='balance-container'>
                    <BalanceFooter content={content}></BalanceFooter>
                </div>
            </div>
        );

    }

    render() {
        const content = FertilizersCalculationTables.renderTable(
            this.state.columns_main,
            this.state.columns_pre_sowing,
            this.state.columns_feed,
            this.state.main_rows,
            this.state.pre_sowing_rows,
            this.state.feed_rows,
            this.state.balance_row,
            this.state.balance_columns,
            this.calculateFertilizers,
            this.addRow,
            this.handleChangeCoefP,
            this.props.coefP,
            this.isDisable,
            this.props.showModal,
            this.props.useInputPrice,
            this.props.setUseInputPrice,
        );
        return (
            this.props.visible ?
                <>
                    <div key={this.state.update}>
                        {content}
                    </div>
                </>
                : <></>
        )
    }

    async populateData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')
        const priceFormat = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2})

        function formatCell(value, price = false) {
            return value ? (price ? priceFormat : numberFormat).format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        const data = this.props.fertilizer_data
        const main_rows = data.main.concat(this.props.changed_rows.filter((r) => r.visible))

        const pre_sowing_rows = data.pre_sowing
        const feed_rows = data.feed
        const balance_row = this.props.balance
        let fertilizers_mineral_list_full = this.props.fertilizer_mineral_list
        let fertilizers_mineral_list = []
        fertilizers_mineral_list_full.map((r) => fertilizers_mineral_list.push({
            value: r.id,
            label: r.name,
            element: r.element,
            price: r.price
        }))

        let changed_rows = this.props.changed_rows

        const onMainChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.state.main_rows.find((row) => {
                return row.id === rowId
            });
            set(rowRegion, field, value)
            this.recalculateRows(main_rows)
            const i = changed_rows.findIndex((r) => r.id === rowId)
            if (i < 0) {
                changed_rows.push({
                    id: "n".concat(rowRegion.id),
                    fertilizerId: rowRegion.fertilizerId,
                    fertilizer_count: rowRegion.fertilizer_count,
                    price: rowRegion.price,
                    element: rowRegion.element,
                    visible: true
                })
            }
            this.props.not_calculate_fertilizers_list.clear()
            changed_rows.map((row) => this.props.not_calculate_fertilizers_list.add(row.fertilizerId))
            this.calcBalance(false)
            this.props.recalculate_A_c()
        }
        const onPreSowingChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.state.pre_sowing_rows.find((row) => {
                return row.id === rowId
            });
            set(rowRegion, field, value)
            this.setState({update: !this.state.update})
            this.recalculateRows(this.state.pre_sowing_rows)
            this.calcBalance(false)
            this.props.calculate_main()
        }
        const onFeedChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.state.feed_rows.find((row) => {
                return row.id === rowId
            });
            set(rowRegion, field, value)
            this.setState({update: !this.state.update})
            this.recalculateRows(this.state.feed_rows)
            this.calcBalance(false)
            this.props.calculate_main()
        }

        const onMainFertilizerChange = (rowId, field) => (value) => {
            const row = this.state.main_rows.find((row) => {
                return row.id === rowId;
            });
            if (value.value !== 0) {
                let fertilizer = this.props.fertilizer_mineral_list.find((f) => {
                    return f.id === value.value;
                })
                row.fertilizerId = fertilizer.id
            }
            const i = changed_rows.findIndex((r) => r.id === rowId)
            set(row, field, value.value);
            this.recalculateRows(this.state.main_rows)
            if (i < 0) {
                changed_rows.push({
                    id: "n".concat(row.id),
                    fertilizerId: row.fertilizerId,
                    fertilizer_count: row.fertilizer_count,
                    price: row.price,
                    element: row.element,
                    visible: true
                })
            }
            this.props.not_calculate_fertilizers_list.clear()
            changed_rows.map((row) => this.props.not_calculate_fertilizers_list.add(row.fertilizerId))
            this.calcBalance(false)
            this.props.recalculate_A_c()

        }
        const onPreSowingFertilizerChange = (rowId, field) => (value) => {
            const row = this.state.pre_sowing_rows.find((row) => {
                return row.id === rowId;
            });
            if (value.value !== 0) {
                let fertilizer = this.props.fertilizer_mineral_list.find((f) => {
                    return f.id === value.value;
                })
                row.fertilizerId = fertilizer.id
            }
            set(row, field, value.value);
            this.setState({update: !this.state.update})
            this.recalculateRows(this.state.pre_sowing_rows)
            this.calcBalance(false)
            this.props.calculate_main()
        }
        const onFeedFertilizerChange = (rowId, field) => (value) => {
            const row = this.state.feed_rows.find((row) => {
                return row.id === rowId;
            });
            if (value.value !== 0) {
                let fertilizer = this.props.fertilizer_mineral_list.find((f) => {
                    return f.id === value.value;
                })
                row.fertilizerId = fertilizer.id
            }
            set(row, field, value.value);
            this.setState({update: !this.state.update})
            this.recalculateRows(this.state.feed_rows)
            this.calcBalance(false)
            this.props.calculate_main()
        }

        const onElementChange = (rowId, field, table) => (value1) => {
            let value = value1.replace(/\s/g, "")
            const rowRegion = this.state[table].find((row) => {
                return row.id === rowId
            });
            set(rowRegion.element, field, value)
            this.recalculateRowFromElements(rowRegion, field)
            if (table === 'main_rows') {
                const i = changed_rows.findIndex((r) => r.id === rowId)
                if (i < 0) {
                    changed_rows.push({
                        id: "n".concat(rowRegion.id),
                        fertilizerId: rowRegion.fertilizerId,
                        fertilizer_count: rowRegion.fertilizer_count,
                        price: rowRegion.price,
                        element: rowRegion.element,
                        visible: true
                    })
                }
                this.props.not_calculate_fertilizers_list.clear()
                changed_rows.map((row) => this.props.not_calculate_fertilizers_list.add(row.fertilizerId))
                this.calcBalance(false)
                this.props.recalculate_A_c()
            } else {
                this.calcBalance(false)
                this.props.calculate_main()
            }
        }

        // const onInputPriceChange = (rowId, field, table) => (value1) => {
        //     let value = value1.replace(/\s/g, "")
        //     const rowRegion = this.state[table].find((row) => {
        //         return row.id === rowId
        //     });
        //     set(rowRegion, field, value)
        //     this.calcBalance(true)
        // }

        const del_button = (id, field) => {
            return (<button className="delete-fertilizer-row-btn"
                            onClick={() => this.deleteRow(id, field)}>
                <img src={del} alt='del'/></button>)
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const balance_columns = [
            {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value="Баланс"
                            focus={focus}
                        />
                    );
                },
                id: 'balance',
                width: 36,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.n, "n")}>
                            <Input
                                value={formatCell(-row.element.n)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'N',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.p2O5, 'p2O5')}>
                            <Input
                                value={formatCell(-row.element.p2O5)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'P2O5',
                width:9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.k2O, 'k2O')}>
                            <Input
                                value={formatCell(-row.element.k2O)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'K2O',
                width:9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.s, 's')}>
                            <Input
                                value={formatCell(-row.element.s)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'S',
                width:9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.caO, 'caO')}>
                            <Input
                                value={formatCell(-row.element.caO)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width:9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.BalanceBackLight(row.element.mg, 'mg')}>
                            <Input
                                value={formatCell(-row.element.mg)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div>
                            <Input
                                value={formatCell(row.price, true)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'price',
                width: 10,
            }
            // }, {
            //     title: '',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={useInputPrice?'':' disable'}>
            //                 <Input
            //                     value={formatCell(row.input_price, true)}
            //                     focus={focus}
            //                 />
            //             </div>
            //         );
            //     },
            //     id: 'intro_price',
            //     width: 8,
            // }

        ];
        const columns_main = [
            {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="234px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    margin: '0 auto',
                                    width: '90%',
                                    height: '50px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '50px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: '#201E44',
                                    height: '46px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            placeholder='Выберите удобрение'
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}
                            id="fertilizer-mineral-select"
                            defaultValue={fertilizers_mineral_list[fertilizers_mineral_list.findIndex((r) => r.value === row.fertilizerId)]}
                            options={fertilizers_mineral_list}
                            isOpen={focus}
                            onChange={onMainFertilizerChange(row.id, 'fertilizerId')}
                        />
                    )
                },
                id: 'fertilizer_type',
                width: 26,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div
                            className={'fertilizer-count-cell ' + (row.id.toString().includes('n') ? 'change-cell' : '')}>
                            {/* eslint-disable-next-line eqeqeq */}
                            <div className={row.fertilizer_count == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.fertilizer_count)}
                                    selectTextOnFocus={true}
                                    focus={focus}
                                    onChange={onMainChange(row.id, 'fertilizer_count')}
                                />
                            </div>
                        </div>
                    );
                },
                id: 'fertilizer_count',
                width: 10
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}>
                            <Input
                                value={formatCell(row.element.n)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'n', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'N',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}>
                            <Input
                                value={formatCell(row.element.p2O5)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'p2O5', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'P2O5',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}>
                            <Input
                                value={formatCell(row.element.k2O)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'k2O', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'K2O',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('s') + (row.id.toString().includes('n') ? 'change-cell' : '')}>
                            <Input
                                value={formatCell(row.element.s)}
                                focus={focus}
                                onChange={onElementChange(row.id, 's', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('caO') + (row.id.toString().includes('n') ? 'change-cell' : '')}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'caO', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('mg') + (row.id.toString().includes('n') ? 'change-cell' : '')}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'mg', 'main_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 9,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div>
                            <Input
                                selectTextOnFocus={true}
                                value={formatCell(row.price, true)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'price',
                width: 10,
            },
            {
                title: '',
                value: (row) => {
                    return del_button(row.id, 'main_rows');
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
            // , {
            //     title: '',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={useInputPrice?'':'disable'}>
            //                 <Input
            //                     selectTextOnFocus={true}
            //                     value={formatCell(row.input_price, true)}
            //                     focus={focus}
            //                     onChange={onInputPriceChange(row.id, 'input_price', 'main_rows')}
            //                 />
            //             </div>
            //         );
            //     },
            //     id: 'intro_price',
            //     width: 8,
            // }
        ];
        const columns_pre_sowing = [
             {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="235px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    margin: '0 auto',
                                    width: '90%',
                                    height: '50px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '50px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: '#201E44',
                                    height: '46px',
                                    paddingTop: '15px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            placeholder='Выберите удобрение'
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}
                            defaultValue={fertilizers_mineral_list[fertilizers_mineral_list.findIndex((r) => r.value === row.fertilizerId)]}
                            options={fertilizers_mineral_list}
                            onChange={onPreSowingFertilizerChange(row.id, 'fertilizerId')}
                        />
                    )
                },
                id: 'fertilizer_type',
                width: 26,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className="fertilizer-count-cell">
                            {/* eslint-disable-next-line eqeqeq */}
                            <div className={row.fertilizer_count == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.fertilizer_count)}
                                    selectTextOnFocus={true}
                                    focus={focus}
                                    onChange={onPreSowingChange(row.id, 'fertilizer_count')}
                                />
                            </div>
                        </div>
                    );
                },
                id: 'fertilizer_count',
                width: 10
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.n)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'n', 'pre_sowing_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'N',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.p2O5)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'p2O5', 'pre_sowing_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'P2O5',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.k2O)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'k2O', 'pre_sowing_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'K2O',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('s')}>
                            <Input
                                value={formatCell(row.element.s)}
                                focus={focus}
                                onChange={onElementChange(row.id, 's', 'pre_sowing_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('caO')}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'caO', 'pre_sowing_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('mg')}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'mg', 'pre_sowing_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div>
                            <Input
                                value={formatCell(row.price, true)}
                                selectTextOnFocus={true}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'price',
                width: 10,
            },
            {
                title: '',
                value: (row) => {
                    return del_button(row.id, 'pre_sowing_rows')
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
            // , {
            //     title: '',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={useInputPrice?'':'disable'}>
            //                 <Input
            //                     value={formatCell(row.input_price, true)}
            //                     focus={focus}
            //                     selectTextOnFocus={true}
            //                     onChange={onInputPriceChange(row.id, 'input_price', 'pre_sowing_rows')}
            //                 />
            //             </div>
            //         );
            //     },
            //     id: 'intro_price',
            //     width: 8,
            // }
        ];
        const columns_feed = [
            {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight="235px"
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    margin: '0 auto',
                                    width: '90%',
                                    height: '50px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '50px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: '#201E44',
                                    height: '46px',
                                    paddingTop: '15px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            placeholder='Выберите удобрение'
                            className={row.id.toString().includes('n') ? 'change-cell' : ''}
                            defaultValue={fertilizers_mineral_list[fertilizers_mineral_list.findIndex((r) => r.value === row.fertilizerId)]}
                            options={fertilizers_mineral_list}
                            isOpen={focus}
                            onChange={onFeedFertilizerChange(row.id, 'fertilizerId')}
                        />
                    )
                },
                id: 'fertilizer_type',
                width: 26,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className="fertilizer-count-cell">
                            {/* eslint-disable-next-line eqeqeq */}
                            <div className={row.fertilizer_count == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.fertilizer_count)}
                                    selectTextOnFocus={true}
                                    focus={focus}
                                    onChange={onFeedChange(row.id, 'fertilizer_count')}
                                />
                            </div>
                        </div>
                    );
                },
                id: 'fertilizer_count',
                width: 10
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.n)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'n', 'feed_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'N',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.p2O5)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'p2O5', 'feed_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'P2O5',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.k2O)}
                            focus={focus}
                            onChange={onElementChange(row.id, 'k2O', 'feed_rows')}
                            selectTextOnFocus={true}
                        />
                    );
                },
                id: 'K2O',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('s')}>
                            <Input
                                value={formatCell(row.element.s)}
                                focus={focus}
                                onChange={onElementChange(row.id, 's', 'feed_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('caO')}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'caO', 'feed_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.isDisable('mg')}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                                onChange={onElementChange(row.id, 'mg', 'feed_rows')}
                                selectTextOnFocus={true}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 9
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div>
                            <Input
                                selectTextOnFocus={true}
                                value={formatCell(row.price, true)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'price',
                width: 10,
            },{
                title: '',
                value: (row) => {
                    return del_button(row.id, 'feed_rows');
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
            // , {
            //     title: '',
            //     value: (row, {focus}) => {
            //         return (
            //             <div className={useInputPrice?'':'disable'}>
            //                 <Input
            //                     selectTextOnFocus={true}
            //                     value={formatCell(row.input_price, true)}
            //                     focus={focus}
            //                     onChange={onInputPriceChange(row.id, 'input_price', 'feed_rows')}
            //                 />
            //             </div>
            //         );
            //     },
            //     id: 'intro_price',
            //     width: 8,
            // }
        ];

        this.setState({
            main_rows: main_rows,
            pre_sowing_rows: pre_sowing_rows,
            feed_rows: feed_rows,
            balance_row: balance_row,
            columns_main: columns_main,
            columns_pre_sowing: columns_pre_sowing,
            columns_feed: columns_feed,
            balance_columns: balance_columns,
            fertilizers_mineral_list: fertilizers_mineral_list,
        }, () => {
            this.recalculateRows(this.state.main_rows)
            this.recalculateRows(this.state.feed_rows)
            this.recalculateRows(this.state.pre_sowing_rows)
            if (this.props.balance.length !== 0) {
                this.calcBalance(true)
            }
        })
    }
}
